import api from "api/axios";

export interface BlockedCompany {
  id: number;
  name: string;
  domain: string | null;
  reason: string | null;
  is_active: boolean;
  created_at: string | null;
}

export interface BlockedCompanyCreate {
  name: string;
  domain?: string;
  reason?: string;
}

export async function listBlockedCompanies(): Promise<BlockedCompany[]> {
  const res = await api.get("/admin/blocked-companies");
  return res.data;
}

export async function createBlockedCompany(payload: BlockedCompanyCreate): Promise<BlockedCompany> {
  const res = await api.post("/admin/blocked-companies", payload);
  return res.data;
}

export async function deleteBlockedCompany(id: number): Promise<void> {
  await api.delete(`/admin/blocked-companies/${id}`);
}
